import Vue from 'vue'
import watermark from '@dp/watermark'

import App from './App.vue'
import router from './router'
import store from './store/index'
import api from './utils/api'
import '@/utils/i18n'

import './utils/moment-setup'

import '@ss/mtd-vue/lib/theme2/index.css'
import MTD from '@ss/mtd-vue'
import '@ss/mtd-vue-mobile/lib/styles/index.css'
import MTDM from '@ss/mtd-vue-mobile'
import VueClipboard from 'vue-clipboard2';
import Chart from '@ss/mtdv';


Vue.use(VueClipboard);
Vue.use(MTD);
Vue.use(MTDM);
Vue.component('Chart', Chart);

Vue.config.productionTip = false;

if (process.env.NODE_ENV !== 'development') {
  // 增加水印
  watermark(document.body, {
    backgroundColor: '#f2f4f9',
    urlPrefix: '/api-wm'
  })
} else {
  Vue.prototype.$handleError = (error, extra, ...args) => {
    console.log(error, extra, ...args)
  }
}

// with promise
const url = window.location.href;
if (url.indexOf('sso_complaint') === -1 && url.indexOf('intercept') === -1) {
  api.get('/api/client_sso_auth').then((response) => {
    if (response && response.data === 'success') {
      store.dispatch('build_main').then(() => {
        new Vue({
          router,
          store,
          render: (h) => h(App)
        }).$mount('#app');
      })
    }
  })
} else {
  store.dispatch('api_get_login_user_no_logout').then(() => {
    new Vue({
      router,
      store,
      render: (h) => h(App)
    }).$mount('#app');
  });
}
